import { cn } from "@/lib/utils";
import { ArrowUp, ArrowDown } from "lucide-react";

export function DeltaBadge({ delta }: { delta: number | null }) {
  if (delta === null || delta === 0) return null;
  const isPositive = delta > 0;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-0.5 text-[10px] tabular-nums font-medium",
        isPositive ? "text-green-600" : "text-red-500"
      )}
    >
      {isPositive ? <ArrowUp className="h-2.5 w-2.5" /> : <ArrowDown className="h-2.5 w-2.5" />}
      {Math.abs(delta).toFixed(1)}%
    </span>
  );
}
